import api from '../../api';
import {userIdPath} from '../../helpers/apiHelper';
import {characteristic, type Characteristic} from '../../models/booking/resourceModel';
import {spaceStructure, type SpaceStructure} from '../../models/booking/spaceModels';
import {parseZodSchema} from '../../models/parseZodSchema';

export async function getSpaceStructure(userId?: string): Promise<SpaceStructure> {
    return api
        .get(`/api/space/list${userIdPath(userId)}`)
        .then(api.handle)
        .catch(api.error)
        .then(raw => parseZodSchema(raw, spaceStructure));
}

export async function getAdminSpaceStructure(): Promise<SpaceStructure> {
    return api
        .get('/api/admin/space/list')
        .then(api.handle)
        .catch(api.error)
        .then(raw => parseZodSchema(raw, spaceStructure));
}

export async function getLocationCharacteristics(locationId: string): Promise<Characteristic[]> {
    return api
        .get(`/api/location/${locationId}/characteristic/list`)
        .then(api.handle)
        .catch(api.error)
        .then(raw => parseZodSchema(raw, characteristic.array()));
}

export async function uploadSpaceImage(spaceId: string, payload: FormData): Promise<void> {
    return api.post(`/api/admin/space/${spaceId}`, payload).then(api.handle).catch(api.error);
}

export async function deleteSpaceImage(spaceId: string): Promise<void> {
    return api.delete(`/api/admin/space/${spaceId}`).then(api.handle).catch(api.error);
}

export async function getSpaceImage(spaceId: string): Promise<string | null> {
    try {
        const response = await api.get(`/image/space-image/${spaceId}`);

        if (!response.ok) {
            return null;
        }

        const blob = await response.blob();

        return (URL || webkitURL).createObjectURL(blob);
    } catch {
        return null;
    }
}
